module.exports = __webpack_public_path__ + "static/media/12.173d0f81.jpg";